import type { ExcludeOtherPaymentMethod } from '@/types/common';
import { PaymentMethodEnum } from '@/types/common';
import CreditCard from '@/assets/icons/payments/credit-card-empty.svg';
import Paypal from '@/assets/icons/payments/paypal.svg';
import GooglePay from '@/assets/icons/payments/googleBlackText.svg';
import ApplePay from '@/assets/icons/payments/applePay.png';
import CashApp from '@/assets/icons/payments/cashapp.svg';
import Klarna from '@/assets/icons/payments/klarna.svg';
import Link from '@/assets/icons/payments/link.svg';
import UnionPay from '@/assets/icons/payments/unionpay.svg';
import Verifone from '@/assets/icons/payments/verifone.svg';
import AmazonPay from '@/assets/icons/payments/amazon.svg';
import Venmo from '@/assets/icons/payments/venmo.svg';
import Ideal from '@/assets/icons/payments/iDeal.svg';
import Affrim from '@/assets/icons/payments/Affrim.svg';
import PixPay from '@/assets/icons/payments/logo-pix.png';
import Neosurf from '@/assets/icons/payments/neosurf.svg';
import Blik from '@/assets/icons/payments/blik.png';
import P24 from '@/assets/icons/payments/p24.png';
import AfterPay from '@/assets/icons/payments/afterpay.png';
import Trustly from '@/assets/icons/payments/trustly.svg';
import EPS from '@/assets/icons/payments/eps.png';
import Bancontact from '@/assets/icons/payments/bancontact.svg';
import Alipay from '@/assets/icons/payments/Alipay.svg';
import Payme from '@/assets/icons/payments/payme.png';

export const AVILABLE_PAYMENT_METHOD_COUNT = 4;

export const REDIRECT_PAYMENT_POLLING_INTERVAL = 1000;

export const MAXIMUM_CREDIT_CARD_ALLOWED = 5;

export const AVILAIBLE_PAYMENT_METHODS_WITHOUT_OTHER = 3;

export const MAX_LENGTH_CVC = 4;

export const TEXT_BY_PAYMENT_METHOD: Record<PaymentMethodEnum, string> = {
  [PaymentMethodEnum.CREDIT_CARD]: 'Pay with debit or credit card',
  [PaymentMethodEnum.PAYPAL]: 'PayPal',
  [PaymentMethodEnum.GOOGLE_PAY]: 'Google Pay',
  [PaymentMethodEnum.OTHER]: '',
  [PaymentMethodEnum.APPLE_PAY]: 'Apple Pay',
  [PaymentMethodEnum.CASH_APP]: 'Cash App',
  [PaymentMethodEnum.KLARNA]: 'Klarna',
  [PaymentMethodEnum.LINK]: 'Link',
  [PaymentMethodEnum.UNIONPAY]: 'UnionPay',
  [PaymentMethodEnum.VERIFON]: 'Verifone',
  [PaymentMethodEnum.AMAZON_PAY]: 'Amazon Pay',
  [PaymentMethodEnum.PIX]: 'Pix Payment',
  [PaymentMethodEnum.VENMO]: 'Venmo',
  [PaymentMethodEnum.AFTERPAY]: 'Afterpay',
  [PaymentMethodEnum.IDEAL]: 'Ideal',
  [PaymentMethodEnum.AFFIRM]: 'Affirm',
  [PaymentMethodEnum.NEOSURF]: 'Neosurf',
  [PaymentMethodEnum.NUVEI_NEOSURF]: 'Neosurf',
  [PaymentMethodEnum.BLIK]: 'Blik',
  [PaymentMethodEnum.BLIK_CHECKOUT]: 'Blik',
  [PaymentMethodEnum.P24]: 'Przelewy 24',
  [PaymentMethodEnum.TRUSTLY]: 'Trustly',
  [PaymentMethodEnum.EPS]: 'EPS',
  [PaymentMethodEnum.BANCONTACT]: 'Bancontact',
  [PaymentMethodEnum.ALIPAY]: 'Alipay',
  [PaymentMethodEnum.PAYME]: 'Payme',
};

export const LOGO_BY_PAYMENT_METHOD: Record<ExcludeOtherPaymentMethod, string> = {
  [PaymentMethodEnum.CREDIT_CARD]: CreditCard,
  [PaymentMethodEnum.PAYPAL]: Paypal,
  [PaymentMethodEnum.GOOGLE_PAY]: GooglePay,
  [PaymentMethodEnum.APPLE_PAY]: ApplePay,
  [PaymentMethodEnum.CASH_APP]: CashApp,
  [PaymentMethodEnum.KLARNA]: Klarna,
  [PaymentMethodEnum.LINK]: Link,
  [PaymentMethodEnum.UNIONPAY]: UnionPay,
  [PaymentMethodEnum.VERIFON]: Verifone,
  [PaymentMethodEnum.AMAZON_PAY]: AmazonPay,
  [PaymentMethodEnum.VENMO]: Venmo,
  [PaymentMethodEnum.PIX]: PixPay,
  [PaymentMethodEnum.AFTERPAY]: AfterPay,
  [PaymentMethodEnum.IDEAL]: Ideal,
  [PaymentMethodEnum.AFFIRM]: Affrim,
  [PaymentMethodEnum.NEOSURF]: Neosurf,
  [PaymentMethodEnum.NUVEI_NEOSURF]: Neosurf,
  [PaymentMethodEnum.BLIK]: Blik,
  [PaymentMethodEnum.BLIK_CHECKOUT]: Blik,
  [PaymentMethodEnum.P24]: P24,
  [PaymentMethodEnum.TRUSTLY]: Trustly,
  [PaymentMethodEnum.EPS]: EPS,
  [PaymentMethodEnum.BANCONTACT]: Bancontact,
  [PaymentMethodEnum.ALIPAY]: Alipay,
  [PaymentMethodEnum.PAYME]: Payme,
};
